import type { User } from "../types";

/** مستخدم مربوط بمديرية واحدة (غير مدير النظام) — BR-09 */
export function isDirectorateScoped(user: User | null | undefined): boolean {
  return user?.directorateId != null && user.role !== "SYSTEM_ADMIN";
}

export function myDirectorateReportPath(user: User | null | undefined): string | null {
  if (!user?.directorateId) return null;
  return `/summary/directorate/${user.directorateId}`;
}

const BLOCKED_FOR_SCOPED = [
  "/summary/directorates",
  "/summary/governorates",
];

export function isRouteBlockedForScopedUser(pathname: string, user: User | null | undefined): boolean {
  if (!isDirectorateScoped(user)) return false;
  return BLOCKED_FOR_SCOPED.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}
